<mat-card class="product-card">
  <mat-card-content>
    <nav mat-tab-nav-bar class="navigation-tabs">
      <a
        mat-tab-link
        [routerLink]="['./general']"
        routerLinkActive
        #general="routerLinkActive"
        [active]="general.isActive"
      >
        {{ 'labels.heading.General' | translate }}
      </a>
      <ng-container *ngFor="let fixedDepositDatatable of fixedDepositDatatables">
        <a
          mat-tab-link
          [routerLink]="['./datatables', fixedDepositDatatable.registeredTableName]"
          routerLinkActive
          #datatable="routerLinkActive"
          [active]="datatable.isActive"
          *mifosxHasPermission="'READ_' + fixedDepositDatatable.registeredTableName"
        >
          {{ fixedDepositDatatable.registeredTableName }}
        </a>
      </ng-container>
    </nav>

    <router-outlet></router-outlet>
  </mat-card-content>
</mat-card>
